import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "option-tile" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "rate-plan-info" }
const _hoisted_4 = { class: "rate-options" }
const _hoisted_5 = { class: "rate-and-term-wrapper" }
const _hoisted_6 = { class: "rate-wrapper" }
const _hoisted_7 = { class: "rate" }
const _hoisted_8 = { class: "rates-tooltip" }
const _hoisted_9 = { class: "term-wrapper" }
const _hoisted_10 = { class: "term" }
const _hoisted_11 = { class: "repayment-terms-tooltip" }
const _hoisted_12 = { class: "rate-options" }
const _hoisted_13 = { class: "show-options-wrapper" }

import { computed } from "vue";
import { useStore } from "vuex";
import usePaymentOptions from "@/use/paymentOptions";
import RepaymentOption from "@/components/loan-configuration/RepaymentOption.vue";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import Icon from "@/components/shared/Icon.vue";
import type { RatePlanRepaymentVM, RatePlanVM, RateTypeSection } from "@/models/loanConfiguration";
import { RateTypeIds } from "@/config/constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoanOption',
  props: {
    ratePlan: {},
    schoolSelected: { type: Boolean },
    requestedAmount: {}
  },
  emits: ["toggleRepayments", "update:repaymentType"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const { formatRatePercentages, formatStartOfQuarter } = usePaymentOptions();

const loanConfigurationModule = computed(() => store.state.loanConfigurationModule);

const coApplicantTypeDisplayName = computed<string>(() =>
  store.getters["coApplicantTypeDisplayName"].toLowerCase(),
);

function getRateTypeDescription(rateTypeId: number) {
  return loanConfigurationModule.value.loanOptionsConfiguration?.rateTypeSections.find(
    (s: RateTypeSection) => s.rateTypeId === rateTypeId,
  )?.rateTypeDescription;
}

const hasRepaymentTermTooltip = computed<boolean>(() => {
  return (
    (props.ratePlan &&
      props.ratePlan?.repaymentTermDetails &&
      props.ratePlan?.repaymentTermDetails?.tooltipText !== null &&
      props.ratePlan?.repaymentTermDetails?.tooltipText !== undefined) === true
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(__props.ratePlan.rateTypeName) + " Interest Rate", 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(getRateTypeDescription(__props.ratePlan.rateTypeId)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(_toDisplayString(__props.ratePlan.rateDisplay), 1),
              _createElementVNode("span", null, [
                (__props.ratePlan.rateTypeId === _unref(RateTypeIds).VARIABLE)
                  ? (_openBlock(), _createBlock(TooltipComponent, {
                      key: 0,
                      class: "right xs-bottom-center-right-auto"
                    }, {
                      toggle: _withCtx(() => [
                        _createElementVNode("sup", null, [
                          _createVNode(Icon, { icon: "info" })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", null, " Current offered rate is calculated using the Index, Margin and Floor value(s) in effect. Your specific Interest Rate, Margin, Floor, and/or credit approval depends upon the credit qualifications of the student borrower and " + _toDisplayString(coApplicantTypeDisplayName.value) + " (if applicable). ", 1),
                          _createElementVNode("p", null, " The \"Index\" for the quarter beginning " + _toDisplayString(_unref(formatStartOfQuarter)(__props.ratePlan?.startOfQuarter)) + " is " + _toDisplayString(_unref(formatRatePercentages)(__props.ratePlan?.indexRate, 3)) + ", which was the Prime index published in the Wall Street Journal on the first business day of " + _toDisplayString(__props.ratePlan?.indexPublishDate) + ". The credit approved margin is " + _toDisplayString(_unref(formatRatePercentages)(__props.ratePlan?.margin, 3)) + ". Floor and Ceiling will be disclosed at account opening. ", 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "Interest Rate", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _createTextVNode(_toDisplayString(__props.ratePlan.repaymentTerm) + " year", 1),
              _createElementVNode("span", null, [
                (hasRepaymentTermTooltip.value)
                  ? (_openBlock(), _createBlock(TooltipComponent, { key: 0 }, {
                      toggle: _withCtx(() => [
                        _createElementVNode("sup", null, [
                          _createVNode(Icon, { icon: "info" })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", null, _toDisplayString(__props.ratePlan.repaymentTermDetails?.tooltipText), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "Repayment Term", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("a", {
            class: "show-options",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleRepayments')))
          }, [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Show Options ", -1),
            _createElementVNode("span", { class: "caret-down" }, null, -1)
          ]))])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["payment-options", { hidden: !__props.ratePlan.paymentOptionsActive }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ratePlan.repayments, (repayment) => {
        return (_openBlock(), _createBlock(RepaymentOption, {
          key: repayment.repaymentTypeId,
          option: repayment,
          ratePlan: __props.ratePlan,
          requestedAmount: __props.requestedAmount,
          schoolSelected: __props.schoolSelected,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:repaymentType', $event)))
        }, null, 8, ["option", "ratePlan", "requestedAmount", "schoolSelected"]))
      }), 128))
    ], 2), [
      [_vShow, __props.ratePlan.paymentOptionsActive]
    ])
  ]))
}
}

})